import { createHashHistory, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { NotFound } from './components/NotFound';

// A factory rather than only a singleton: each router registers its own hash
// history listeners, so tests build one per case instead of sharing navigation
// state. Kept out of App.tsx so that module still exports components only.
export function createAppRouter() {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    history: createHashHistory(),
    defaultNotFoundComponent: NotFound,
  });
}

export const router = createAppRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
